// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ToggleOffIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ToggleOff/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.309 3.679a6.33 6.33 0 0 1-.326 12.65H7.017a6.33 6.33 0 0 1 0-12.658h5.966l.326.008ZM7.017 5.337a4.663 4.663 0 0 0 0 9.326h5.966a4.663 4.663 0 0 0 .24-9.32l-.24-.006H7.017Zm-.602 1.33a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666Z"
}));
export default ToggleOffIcon;
